import departmentReducer from '@/features/departments/stores/department.slice'
import deviceIpReducer from '../slices/DeviceSlice.slice'
import meetingReducer from '../slices/MeetingSlice.slice'
import signalRReducer from '../slices/SignalRSlice.slice'
import appGlobalReducer from '../slices/appGlobal.slice'
const rootReducer = {
  appGlobal: appGlobalReducer,
  department: departmentReducer,
  deviceIp: deviceIpReducer,
  signalR: signalRReducer,
  meeting: meetingReducer,
}

export default rootReducer
